import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FileHandle } from 'src/app/shared/directives/drag-drop.directive';

@Injectable({
  providedIn: 'root'
})
export class LoadingImagesService {

  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
    this.url = environment.apiUrl;
    this.key = environment.apiKey;
  }

  /**
   *
   */
  public getDataByKey(term: string): Observable<object> {

    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('filter', term);

    return this.http
      .get(`${this.url}/titles/searchbykey`, { responseType: 'json', headers, params })
      .pipe(
        catchError(this.errorHandler)
      );
  }

    /**
   *
   * @param form
   * @param attachedFiles
   */
    /* public uploadImage(attachedFiles: File[], userName: string, isbn: string, title: string, currentCover: string): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);
  
      const formData = new FormData();
  
      if (attachedFiles) {
        for (let i = 0; i < attachedFiles.length; i++) {
          formData.append('files', attachedFiles[i]);
        }
      }
  
      const params = new HttpParams()
      .append('userName', userName)
      .append('isbn', isbn)
      .append('title', title)
      .append('currentCover', currentCover);
  
      return this.http
        .post(`${this.url}/images/createimagespdf`, formData, { responseType: 'blob', headers, params })
        .pipe(
          catchError(this.errorHandler)
        );
    } */

    public uploadImage(attachedFiles: File[], userName: string, isbn: string, title: string, oracleKey: string, currentCover: string): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);
  
      const formData = new FormData();
  
      if (attachedFiles) {
        for (let i = 0; i < attachedFiles.length; i++) {
          formData.append('files', attachedFiles[i]);
        }
      }
  
      const params = new HttpParams()
      .append('userName', userName)
      .append('isbn', isbn)
      .append('title', title)
      .append('oraclekey', oracleKey)
      .append('imageType', currentCover);
  
      return this.http
        .post(`${this.url}/images/createimagespdf`, formData, { responseType: 'blob', headers, params })
        .pipe(
          catchError(this.errorHandler)
        );
    }

    public uploadFiles(attachedFiles: File[], userName: string): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);

        const params = new HttpParams()
      .append('username', userName);
  
      const formData = new FormData();
  
      if (attachedFiles) {
        for (let i = 0; i < attachedFiles.length; i++) {
          formData.append('files', attachedFiles[i]);
        }
      }
  
      return this.http
        .post(`${this.url}/images/ManyFilesFichasTecnicas`, formData, { responseType: 'blob', headers })
        .pipe(
          catchError(this.errorHandler)
        );
    }

    /**
   *
   * @param form
   * @param attachedFiles
   */
     public uploadMoleskin(attachedFiles: File[], userName: string, term: string, isbn: string, interiors:string): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);
  
      const formData = new FormData();
  
      if (attachedFiles) {
        for (let i = 0; i < attachedFiles.length; i++) {
          formData.append('files', attachedFiles[i]);
        }
      }
  
      const params = new HttpParams()
      .append('userName', userName)
      .append('isbn', isbn)
      .append('termKey', term)
      .append('interiors', interiors);
  
      return this.http
        .post(`${this.url}/images/createmoleskinpdf`, formData, { responseType: 'blob', headers, params })
        .pipe(
  
          catchError(this.errorHandler)
         
        );
    }

    public uploadFile(attachedFiles: File[]): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);
  
      const formData = new FormData();
  
      if (attachedFiles) {
        for (let i = 0; i < attachedFiles.length; i++) {
          formData.append('files', attachedFiles[i]);
        }
      }
  
      return this.http
        .post(`${this.url}/images/searchURL`, formData, { responseType: 'json', headers })
        .pipe(
  
          catchError(this.errorHandler)
         
        );
    }

    public uploadFileURLSDownloadFile(attachedFiles: File[], purpose: string, format: string): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);
  
      const formData = new FormData();
  
      if (attachedFiles) {
        for (let i = 0; i < attachedFiles.length; i++) {
          formData.append('files', attachedFiles[i]);
        }
      }
      
      const params = new HttpParams()
      .append('purpose', purpose)
      .append('format', format);
  
      return this.http
        .post(`${this.url}/images/searchURLfile`, formData, { responseType: 'blob', headers, params })
        .pipe(
  
          catchError(this.errorHandler)
         
        );
        
    }

    public uploadFileURLS(attachedFiles: File[], purpose: string, format: string): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);
  
      const formData = new FormData();
  
      if (attachedFiles) {
        for (let i = 0; i < attachedFiles.length; i++) {
          formData.append('files', attachedFiles[i]);
        }
      }
      
      const params = new HttpParams()
      .append('purpose', purpose)
      .append('format', format);
  
      return this.http
        .post(`${this.url}/images/searchURL`, formData, { responseType: 'json', headers, params })
        .pipe(
  
          catchError(this.errorHandler)
         
        );
        
    }

    /*public uploadFileURLS(attachedFiles: File[], purpose: string): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);
  
      const formData = new FormData();
  
      if (attachedFiles) {
        for (let i = 0; i < attachedFiles.length; i++) {
          formData.append('files', attachedFiles[i]);
        }
      }
      
      const params = new HttpParams()
      .append('purpose', purpose);
  
      return this.http
        .post(`${this.url}/images/searchURL`, formData, { responseType: 'json', headers, params })
        .pipe(
  
          catchError(this.errorHandler)
         
        );
        
    } */

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error.error);
  }
}
